import DonateView from '../presentation/DonateView';
import React, { useEffect, useState, useCallback } from 'react';
import isEmpty from 'lodash/isEmpty';
import { useHistory } from 'react-router-dom';
import { RESIZE, CUSTOM_ADD_HOPE_DONATE_AMOUNT_REGEX } from 'common/constants/SharedConstants';
import { isMobileDevice } from 'common/utilities/utils';
import { getAddHopeContentData, prepareFormData, onFormElementChangeHandler } from '../utils/DonateUtils';
import { getAddHopeContent } from 'common/utilities/content';
import { contentfulActions, selectContentfulResponse } from '@kfc-global/react-shared/redux/Slices/ContentfulSlice';
import { useAppDispatch, useAppSelector } from '@kfc-global/react-shared/redux/Store/hooks';
import { resetPaymentStatus } from '@kfc-global/react-shared/redux/Actions/PaymentsAction';
import { resetPostOrder } from '@kfc-global/react-shared/redux/Actions/PostOrderAction';

import { useSelector } from 'react-redux';

const DonateContainer = () => {
  const [isMobile, setMobileHeader] = useState(isMobileDevice(window.innerWidth));
  const [segmentedAddHopeData, setSegmentedAddHopeData] = useState({});
  const dispatch = useAppDispatch();
  const history = useHistory();
  const { tenantId, currencyConversionFactor } = useSelector(data => data.tenantReducer || {});
  const { addHopePayResponse } = useSelector(data => data.paymentsReducer || {});
  const addHopeContent = useAppSelector(selectContentfulResponse) ?? {};
  const currencySymbol = useSelector(state => state.tenantReducer?.currencySymbol);
  const [donationsButtonData, setDonationsButtonData] = useState({
    donationChargeOption: [],
    inputFiledValidErrormsg: '',
    customAmount: '',
    addDonationBtnHandler: true,
    showDonationsCustomFields: true,
    showNonDonationPercentage: true,
    editButtonShow: false,
    buttonText: segmentedAddHopeData.addHopeButton,
    showCurrencyField: false,
    defaultTipSelected: false,
  });
  const [addHopeDetails, setAddHopeDetails] = useState({});
  const updateAddHopeDetails = useCallback(param => {
    setAddHopeDetails && setAddHopeDetails(prevState => ({ ...prevState, ...param }));
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    dispatch(getAddHopeContent());
    dispatch(resetPaymentStatus());
    dispatch(resetPostOrder());
    return () => {
      dispatch(contentfulActions.resetReducer());
    };
  }, [dispatch]);

  const windowResized = () => {
    const isMobileView = isMobileDevice(window.innerWidth);
    setMobileHeader(isMobileView);
  };

  useEffect(() => {
    window.addEventListener(RESIZE, windowResized);
  }, [isMobile]);

  useEffect(() => {
    if (!isEmpty(addHopeContent?.addHope)) {
      setSegmentedAddHopeData(getAddHopeContentData(addHopeContent?.addHope?.items?.[0]?.fields));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [addHopeContent?.addHope, history]);

  useEffect(() => {
    if (!isEmpty(segmentedAddHopeData.donationOptions)) {
      const defaultValue = segmentedAddHopeData.defaultDonationValue;
      setDonationsButtonData({
        donationChargeOption: segmentedAddHopeData.donationOptions.map(values => {
          return {
            values,
            displayNonPercentageAmount: values,
            isDefault: values === defaultValue ? true : false,
            isSelected: values === defaultValue ? true : false,
          };
        }),
        showNonDonationPercentage: true,
        showDonationsCustomFields: true,
        addDonationBtnHandler: true,
        inputFiledValidErrormsg: '',
        customAmount: '',
        buttonText: segmentedAddHopeData.addHopeButton,
        donationRegexPattern: CUSTOM_ADD_HOPE_DONATE_AMOUNT_REGEX,
        isAddHopeFlow: true,
        defaultTipSelected: true,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [segmentedAddHopeData.donationOptions]);

  useEffect(() => {
    if (!isEmpty(donationsButtonData)) {
      const AddHopeData = addHopeContent?.addHope;
      updateAddHopeDetails({
        addHopeFormConfig: {
          fieldsConfig: prepareFormData({
            AddHopeData,
            donationsButtonData,
            setDonationsButtonData,
            currencySymbol,
            tenantId,
            dispatch,
            currencyConversionFactor,
          }),
          isFormValid: false,
          onFormChangeHandler: onFormElementChangeHandler,
        },
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [donationsButtonData.donationChargeOption]);

  return (
    <React.Fragment>
      <DonateView
        isMobile={isMobile}
        segmentedAddHopeData={segmentedAddHopeData}
        donationsButtonData={donationsButtonData}
        paymentData={addHopePayResponse}
        addHopeDetails={addHopeDetails}
        updateAddHopeDetails={updateAddHopeDetails}
      />
    </React.Fragment>
  );
};

export default DonateContainer;
